<template>
  <div class="app-grid">
    <!-- grid heading  -->
    <slot name="heading" />
    <!-- if transition needed -->
    <template v-if="transition">
      <transition-group class="app-grid__listing" :class="className" :name="transition" tag="div">
        <!-- content -->
        <slot />
      </transition-group>
    </template>
    <!-- if no transition is needed -->
    <div v-else class="app-grid__listing" :class="className">
      <!-- content -->
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppGrid',

  props: {
    flex: {
      type: Boolean,
      default: false,
    },

    layout: {
      type: String,
      default: 'row',
    },

    transition: {
      type: [String, Boolean],
      default: 'scale-card',
    },
  },

  computed: {
    flexClassName() {
      return this.flex && `app-grid__listing--flex`
    },

    className() {
      return `app-grid__listing--${this.layout}`
    },
  },
}
</script>

<style scoped>
.app-grid {
  position: relative;
}

.app-grid__listing {
  display: grid;
  grid-auto-flow: dense;
  position: relative;
  grid-gap: 20px;
  padding: 20px 0;
}

.app-grid__listing--row {
  grid-template-columns: repeat(auto-fill, minmax(221px, 1fr));
  align-items: stretch;
}

/* Responsive  ------------ */
@media (max-width: 900px) {
}

@media (max-width: 580px) {
  .app-grid__listing {
    justify-content: center;
    grid-template-columns: 1fr;
  }
}
</style>
